import type React from 'react'
import { cn } from '../../../../../../../shared/cn'
import { H1, H2, H3 } from '../../../../../../typography/Heading'
import { MdxFenceCode, MdxFencePre, mdxMarkdownTypographyStyles } from './CodeBlock/codeBlock'

export const mdxHtmlComponents: Record<string, React.ElementType> = {
  img: ({ className, alt, ...props }: React.ComponentPropsWithoutRef<'img'>) => (
    // eslint-disable-next-line @next/next/no-img-element -- framework-agnostic MDX preview
    <img {...props} alt={alt ?? ''} className={cn('max-w-full', className)} />
  ),

  span: ({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) => {
    const classNameString = className ?? ''
    if (classNameString.includes('katex')) {
      return <span {...props} className={cn(classNameString, 'px-1 text-contentPrimary')} />
    }
    return <span {...props} className={className} />
  },

  code: MdxFenceCode,
  pre: MdxFencePre,

  p: ({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) => (
    <p className={cn(mdxMarkdownTypographyStyles.p, className)} {...props} />
  ),
  h1: ({ className, ...props }: React.ComponentPropsWithoutRef<'h1'>) => (
    <H1 className={cn(mdxMarkdownTypographyStyles.h1, className)} {...props} />
  ),
  h2: ({ className, ...props }: React.ComponentPropsWithoutRef<'h2'>) => (
    <H2 className={cn(mdxMarkdownTypographyStyles.h2, className)} {...props} />
  ),
  h3: ({ className, ...props }: React.ComponentPropsWithoutRef<'h3'>) => (
    <H3 className={cn(mdxMarkdownTypographyStyles.h3, className)} {...props} />
  ),
  blockquote: ({ className, ...props }: React.ComponentPropsWithoutRef<'blockquote'>) => (
    <blockquote className={cn(mdxMarkdownTypographyStyles.blockquote, className)} {...props} />
  ),
  a: ({ className, ...props }: React.ComponentPropsWithoutRef<'a'>) => (
    <a className={cn(mdxMarkdownTypographyStyles.a, className)} {...props} />
  ),
  ul: ({ className, ...props }: React.ComponentPropsWithoutRef<'ul'>) => (
    <ul className={cn(mdxMarkdownTypographyStyles.ul, className)} {...props} />
  ),
  ol: ({ className, ...props }: React.ComponentPropsWithoutRef<'ol'>) => (
    <ol className={cn(mdxMarkdownTypographyStyles.ol, className)} {...props} />
  ),
  strong: ({ className, ...props }: React.ComponentPropsWithoutRef<'strong'>) => (
    <strong className={cn(mdxMarkdownTypographyStyles.strong, className)} {...props} />
  ),
  em: ({ className, ...props }: React.ComponentPropsWithoutRef<'em'>) => (
    <em className={cn(mdxMarkdownTypographyStyles.em, className)} {...props} />
  ),
  hr: ({ className, ...props }: React.ComponentPropsWithoutRef<'hr'>) => (
    <hr className={cn(mdxMarkdownTypographyStyles.hr, className)} {...props} />
  ),

  table: ({ className, ...props }: React.ComponentPropsWithoutRef<'table'>) => (
    <div className='my-4 overflow-x-auto'>
      <table className={cn(mdxMarkdownTypographyStyles.table, className)} {...props} />
    </div>
  ),
  thead: ({ className, ...props }: React.ComponentPropsWithoutRef<'thead'>) => (
    <thead className={cn(mdxMarkdownTypographyStyles.thead, className)} {...props} />
  ),
  tbody: ({ className, ...props }: React.ComponentPropsWithoutRef<'tbody'>) => (
    <tbody className={cn(mdxMarkdownTypographyStyles.tbody, className)} {...props} />
  ),
  tr: ({ className, ...props }: React.ComponentPropsWithoutRef<'tr'>) => (
    <tr className={cn(mdxMarkdownTypographyStyles.tr, className)} {...props} />
  ),
  th: ({ className, ...props }: React.ComponentPropsWithoutRef<'th'>) => (
    <th className={cn(mdxMarkdownTypographyStyles.th, className)} {...props} />
  ),
  td: ({ className, ...props }: React.ComponentPropsWithoutRef<'td'>) => (
    <td className={cn(mdxMarkdownTypographyStyles.td, className)} {...props} />
  ),

  input: ({ className, ...props }: React.ComponentPropsWithoutRef<'input'>) => (
    <input
      {...props}
      disabled={false}
      readOnly
      className={cn(mdxMarkdownTypographyStyles.input, className)}
    />
  )
}
